export default async function useShaHash(text: string) {
  if (!text) {
    return undefined;
  }
  const hash = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));
  const hashArray = Array.from(new Uint8Array(hash));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}
